window.initCollectionDescription = function (root) {
  if (!root) return;

  var inner = root.querySelector('[data-collection-desc-inner]');
  var toggle = root.querySelector('[data-collection-desc-toggle]');
  if (!inner || !toggle) return;

  if (root._collectionDescClick) {
    root.removeEventListener('click', root._collectionDescClick);
  }
  if (root._collectionDescResizeObserver) {
    root._collectionDescResizeObserver.disconnect();
    root._collectionDescResizeObserver = null;
  }

  var collapsedLines = parseInt(root.dataset.collapsedLines, 10) || 3;
  var readMore = root.dataset.readMore || 'Read more';
  var readLess = root.dataset.readLess || 'Show less';
  var isDesignMode = root.dataset.designMode === 'true';

  inner.style.setProperty('--collection-desc-lines', collapsedLines);

  function setCollapsed(collapsed) {
    if (collapsed) {
      inner.classList.add('is-collapsed');
      inner.classList.remove('is-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = readMore;
    } else {
      inner.classList.remove('is-collapsed');
      inner.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = readLess;
    }
  }

  function measure() {
    var wasExpanded = inner.classList.contains('is-expanded');

    inner.classList.remove('is-collapsed', 'is-expanded');
    var fullHeight = inner.getBoundingClientRect().height;

    inner.classList.add('is-collapsed');
    var clampedHeight = inner.getBoundingClientRect().height;
    var needsToggle = fullHeight > clampedHeight + 2;

    if (!needsToggle && !isDesignMode) {
      toggle.hidden = true;
      inner.classList.remove('is-collapsed', 'is-expanded');
      return;
    }

    toggle.hidden = false;
    setCollapsed(!wasExpanded);
  }

  root._collectionDescClick = function (event) {
    if (event.target.closest('a[href]')) return;

    var btn = event.target.closest('[data-collection-desc-toggle]');
    if (!btn || !root.contains(btn)) return;
    event.preventDefault();
    event.stopPropagation();

    if (inner.classList.contains('is-expanded')) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  };

  root.addEventListener('click', root._collectionDescClick);

  measure();
  requestAnimationFrame(measure);
  setTimeout(measure, 50);
  setTimeout(measure, 300);

  if (typeof ResizeObserver !== 'undefined') {
    root._collectionDescResizeObserver = new ResizeObserver(function () {
      if (!inner.classList.contains('is-expanded')) {
        measure();
      }
    });
    root._collectionDescResizeObserver.observe(inner);
  } else {
    window.addEventListener('resize', measure);
  }
};

(function () {
  function initInContainer(container) {
    if (!container) return;
    var roots = container.matches && container.matches('[data-collection-description]')
      ? [container]
      : Array.prototype.slice.call(container.querySelectorAll('[data-collection-description]'));
    roots.forEach(function (root) {
      window.initCollectionDescription(root);
    });
  }

  function initAll() {
    initInContainer(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initInContainer(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll();
  });

  document.addEventListener('shopify:section:select', function (event) {
    initInContainer(event.target);
    setTimeout(function () {
      initInContainer(event.target);
    }, 100);
  });
})();
